import React, { useCallback } from 'react'
import { useTranslation } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import AbiEntrySummaryKeys from '../../../constants/locale/key/AbiEntrySummary'

const ABIEntrySummaryTranslationContext = React.createContext()

const ABIEntrySummaryTranslationConsumer = ABIEntrySummaryTranslationContext.Consumer

const ABIEntrySummaryTranslationProvider = ({ children }) => {
    const { translate } = useTranslation([
        Namespace.ABI_ENTRY_SUMMARY
    ])

    const translation = {
        ABI_ENTRY_SUMMARY: {
            ABIEntrySummaryHeader: translate(Namespace.ABI_ENTRY_SUMMARY, AbiEntrySummaryKeys.HEADER),
            ABIEntrySummaryCrEntity: translate(Namespace.ABI_ENTRY_SUMMARY, AbiEntrySummaryKeys.CR_ENTITY),
            ABIEntrySummaryLineItems: translate(Namespace.ABI_ENTRY_SUMMARY, AbiEntrySummaryKeys.LINE_ITEMS)
        }
    }

    const getTranslatedText = useCallback((namespace, key) => {
        if (!namespace || !key) return undefined

        return translation?.[namespace]?.[key] || undefined
    }, [])

    return (
        <ABIEntrySummaryTranslationContext.Provider value={{ translation, getTranslatedText }}>
            {children}
        </ABIEntrySummaryTranslationContext.Provider>
    )
}

export default ABIEntrySummaryTranslationProvider

export { ABIEntrySummaryTranslationContext, ABIEntrySummaryTranslationConsumer }
